import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController } from 'ionic-angular';
import moment from 'moment';
import { GN } from '../../../../gn';
import { CalendarPage } from '../../../calendar/calendar';
import { DIC } from '../../../dic';
import { PopupPage } from '../../../popup/popup';

/**
 * Generated class for the EditpinemployeePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editpinemployee',
  templateUrl: 'editpinemployee.html',
})
export class EditpinemployeePage {
  loadingData: boolean = false;
  Organisations: any;
  pe: any;
  cb: any;
  Title = ''
  _bornDate: any = new Date()
  _borndateDT
  myToast: any
  users = []
  _userid = 0
  _name = ''
  _pin = ''
  selectedEmplName = ''
  selectedEmplIds = ''




  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public toastCtrl: ToastController) {
    this.pe = navParams.get('pe')
    this.cb = navParams.get('cb');
    if (this.pe.id == -1) {
      this.Title = this.dic.l["addpinemployee"]
      this.selectedEmplName = '-- ' + this.dic.l["SelectEmployee"] + ' --'
      this._bornDate = moment(this._bornDate).format(this.gn.user.DFormat)
    } else {
      //debugger
      this._bornDate = moment(this.pe.borndate).format(this.gn.user.DFormat)
      this._borndateDT = this.pe.borndate
      this._name = this.pe.fullname
      this.selectedEmplName = this.pe.username
      this.selectedEmplIds = this.pe.userid
      this._pin = this.pe.pinnumber1 + ''
      //debugger
      this.Title = this.dic.l["editpinemployee"] + ' ' + this._name
      //debugger
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EditpinemployeePage');
    this.loadUsersPinEmployee()
  }

  loadUsersPinEmployee() {
    // this.loadingData = true
    var _that = this
    this.gn._Post('/api/gn/getUsersForPinEmployee', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      for (let i = 0; i < _data.length; i++) {
        _data[i].name = _data[i].fullname
      }
      _that.users = _data
      // _that.loadingData = false
    })
  }


  pickDriver(_ev) {
    if (this.users.length > 0) {
      var _that = this
      let popover = this.popoverCtrl.create(PopupPage, {
        type: 'Drivers', selected: '', arrayData: this.users, callback: function (_text, _ids) {
          _that.selectedEmplName = _text
          _that.selectedEmplIds = _ids
        }
      });
      popover.present({ ev: _ev });
    } else {
      const toast = this.toastCtrl.create({ message: this.dic.l["noallowdriver"], duration: 3000, position: 'top' });
      toast.present();
    }
  }



  openDatePopup(_ev, _startend) {
    var _that = this;

    var tmpd;
    if (_startend == 's')
      tmpd = this._borndateDT;

    let popover = this.popoverCtrl.create(CalendarPage, {
      d: tmpd, cb: function (d) {
        if (_startend == 's') {
          _that._borndateDT = d;
          _that._bornDate = moment(_that._borndateDT).format(_that.gn.user.DFormat)
        }
      }
    })
    popover.present({ ev: _ev });
  }

  addNewPinEmployee() {
    // borndate: this.gn.crypt(moment(this._borndateDT).format('YYYY-MM-DD')),

    if (this.myToast != null) {
      return
    }

    if (this._name == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["entername"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    //debugger

    this._pin = this._pin + ''
    var pinlength = this._pin.length
    if (pinlength != 4) {
      let toast = this.toastCtrl.create({ message: this.dic.l["pinnumber4"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.isNumber(this._pin + '') == false) {
      let toast = this.toastCtrl.create({ message: this.dic.l["pinnumber4"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this.selectedEmplIds + '' == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["chooseuser"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    var _dat = {
      id: this.gn.crypt(this.pe.id),
      name: this.gn.crypt(this._name),
      pin: this.gn.crypt(this._pin),
      userid: this.gn.crypt(this.selectedEmplIds),
      clientid: this.gn.crypt(this.gn.user.ClientId),
      borndate: this.gn.crypt(moment(this._borndateDT).format('YYYY-MM-DD')),
    }
    var _that = this
    _that.gn.loadWaiting();
    this.gn._Post('/api/gn/insertPinEmployee', _dat, function (_data) {
      if (_data.msg == "error") {
        _that.gn.loaderWaiting.dismiss();
        let toast = _that.toastCtrl.create({ message: _that.dic.l["haspin"], duration: 3000, position: 'top' });
        toast.present();
        return
      } else {
        _that.gn.loaderWaiting.dismiss();
        var _cb = _that.navParams.get('cb')
        if (_cb != null) {
          _cb()
        }
        var _msg = _that.dic.l["succaddpinEmp"]
        // if (_that.jo.id + '' != '-1') {
        //   _msg = _that.dic.l["succEditJobs"]
        // }
        let toast = _that.toastCtrl.create({
          message: _msg,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        _that.navCtrl.pop()
      }
    })
  }


  isNumber(numb) {
    if (numb + '' != '' && numb % 1 === 0) {
      return true
    }
    else {
      return false
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/pinemployee/editpinemployee/editpinemployee.ts